import { createContext, useEffect, useState } from 'react';

import { useRNQuery, UseRNQuery } from '../hooks/useRNQuery';
import { reactNativeWindow } from '../utils/get-native-window';
export const RNQueryContext = createContext<
  Omit<UseRNQuery, 'register' | 'onMessage'> & { initiated: boolean }
>(null);

export const RNQueryContextProvider = ({ children }) => {
  const [initiated, setInitiated] = useState<boolean>(false);

  const { register, ...value } = useRNQuery();

  useEffect(() => {
    if (!window.isNativeApp) {
      return;
    }
    register(
      (message) => {
        reactNativeWindow.ReactNativeWebView.postMessage(message);
      },
      (cb) => {
        reactNativeWindow.ReactNativeWebView.onMessage = (message) => {
          cb(message);
        };
        window.addEventListener('message', (message) => {
          cb(message.data);
        });
        document.addEventListener('message', (message) => {
          // @ts-ignore
          cb(message.data);
        });
      }
    );

    // bind console.log to RNQuery
    const _log = console.log;
    console.log = (...args: any) => {
      value.send('log', { payload: args });
      _log(...args);
    };
    setInitiated(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RNQueryContext.Provider value={{ ...value, initiated }}>
      {children}
    </RNQueryContext.Provider>
  );
};
